/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    id: 'authDaterange',
    tip: '提交时间',
    // key: 'authDaterange',
    required: false,
    slot: 'daterange',
    type: 'datetimerange',
    format: 'yyyy-MM-dd HH:mm:ss',
    rangeValue: [],
    key: ['submitDtStart', 'submitDtEnd'],
    text: ['提交时间始', '提交时间止']
  },
  {
    width: 180,
    label: '平台状态',
    tip: '平台状态',
    key: 'auditOssStatus',
    id: 'auditOssStatus',
    slot: 'select',
    clearable: true,
    options: [
      { label: '未提交审核', key: 0 },
      { label: '审核中', key: 1 },
      { label: '审核通过', key: 2 },
      { label: '审核未通过', key: 3 }
    ]
  },
  {
    width: 180,
    label: '活动名称',
    tip: '活动名称',
    key: 'activityName',
    id: 'activityName',
    slot: 'input'
  }
];
